import InfoIcon from '@mui/icons-material/Info';
import { Box, styled } from '@mui/material';

export const StyledInfoIcon = styled(InfoIcon)`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    color: #ffffff;
    fill: #ffffff;
`;
export const StyledTurnaroundBox = styled(Box)<{ marginvalue?: number }>`
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: center;
    margin-top: ${({ marginvalue }) => (marginvalue ? marginvalue : 0)}px;
`;

export const StyledBox = styled(Box)`
    &.proposition {
        background-color: rgba(0, 110, 187, 0.98);
        height: 60px;
        border-radius: 5px;
    }
`;

export const StyledMinTimeBetweenUseBox = styled(Box)`
    height: 30px;
    display: flex;
    align-items: center;
`;

export const StyledIndicatorBox = styled(Box)`
    height: 30px;
    display: flex;
    align-items: center;
    position: absolute;
    left: 100%;
    bottom: 0;
`;

export const StyledPadlockBox = styled(Box)`
    color: white;
    height: 12px;
    min-width: 12px;
    padding: 1px 1px;
    border-radius: 3px;
    display: flex;
    position: absolute;
    margin-left: 3px;
    top: -6px;
    z-index: 3;

    &.ctotYellow {
        background-color: #ffb74d;
    }

    &.ctotRed {
        background-color: #eb3333;
    }

    &.ctotGray {
        background-color: #607d8b;
    }
`;

export const StyledLineBox = styled(Box)`
    border-right: 0;
    border-left: 0;

    &.ctotYellow {
        border: 1px dotted #ffb74d;
    }

    &.ctotRed {
        border: 1px dotted #eb3333;
    }

    &.ctotGray {
        border: 1px dotted #607d8b;
    }

    &.etdGreen {
        border: 1px dotted #00ffbc;
    }
`;

export const StyledCtotEndBox = styled(Box)`
    height: 8px;
    width: 2px;
    border: 1px solid white;

    &.ctotYellow {
        background-color: #ffb74d;
    }

    &.ctotRed {
        background-color: #eb3333;
    }

    &.ctotGray {
        background-color: #607d8b;
    }
`;

export const StyledEtdEndBox = styled(Box)`
    height: 6px;
    width: 6px;
    border: 1px solid white;
    background-color: #00ffbc;
    -ms-transform: rotate(45deg); /* Internet Explorer */
    -moz-transform: rotate(45deg); /* Firefox */
    -webkit-transform: rotate(45deg); /* Safari et Chrome */
    -o-transform: rotate(45deg); /* Opera */
`;
